import { useCallback, useEffect, useState } from 'react';
import type { MinimizableModalView } from '@atlassian/jira-minimizable-modal/src/types.tsx';
import { isMobileAndInMvpOrExistingUsersExperiment } from '@atlassian/jira-mobile-web/src/index.tsx';
import { USER_GIC_POSITIONING_SPOTLIGHT } from '../../common/constants/index.tsx';
import { useUserPreferences } from '../../services/user-preferences/index.tsx';

export const useChangerSpotlight = (minimizableModalView?: MinimizableModalView) => {
	const [allowShowingChangerSpotlight, setAllowShowingChangerSpotlight] = useState(false);
	const [userPreferenceSpotlight, setUserPreferences] = useUserPreferences(
		USER_GIC_POSITIONING_SPOTLIGHT,
		false,
	);
	const hasSeenGicPositioningSpotlight = userPreferenceSpotlight;

	const isMobileExperienceEnabled = isMobileAndInMvpOrExistingUsersExperiment();

	const shouldShowChangerSpotlight =
		!hasSeenGicPositioningSpotlight && allowShowingChangerSpotlight && !isMobileExperienceEnabled;

	const onCloseChangerSpotlight = useCallback(() => {
		if (!hasSeenGicPositioningSpotlight) {
			setAllowShowingChangerSpotlight(false);
			setUserPreferences(true);
		}
	}, [setAllowShowingChangerSpotlight, hasSeenGicPositioningSpotlight, setUserPreferences]);

	const isModalView = minimizableModalView === 'modal';

	useEffect(() => {
		if (!isModalView && shouldShowChangerSpotlight) {
			onCloseChangerSpotlight();
		}
	}, [onCloseChangerSpotlight, isModalView, shouldShowChangerSpotlight]);

	const onOpenSpotlight = () => {
		if (isModalView) setAllowShowingChangerSpotlight(true);
	};

	const onCloseSpotlight = () => {
		if (isModalView) onCloseChangerSpotlight();
	};

	return {
		shouldShowChangerSpotlight,
		onOpenSpotlight,
		onCloseSpotlight,
	};
};
